import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNintendo3dsComponent } from './simple-icons-nintendo3ds.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNintendo3dsComponent ],
    exports:      [ SimpleIconsNintendo3dsComponent ],
    bootstrap:    []
})
export class SimpleIconsNintendo3dsModule {}
